module.exports = __webpack_public_path__ + "static/dispenser-product-3cd262006b201eaf4a3a594f461b809b.png";